// Client layer (TS-2.5.03). A severity badge carrying a non-color signal (the severity's own text
// label, not an icon-only or color-only cue) so the panel remains legible without relying on color
// perception - the WCAG "use of color" failure decisions.md D-227 names as the kind of concrete,
// testable defect this batch's accessibility work targets.
import type { DataQualitySeverity } from "../../api/generated/contracts";
import { strings } from "../../strings";

export interface SeverityBadgeProps {
  readonly severity: DataQualitySeverity;
}

export function SeverityBadge({ severity }: SeverityBadgeProps) {
  return <span className={`eg-severity-badge eg-severity-badge--${severity.toLowerCase()}`}>{strings.dataQuality.severities[severity]}</span>;
}
